import { doc, onSnapshot, setDoc, type Unsubscribe } from 'firebase/firestore'
import { firestoreDb } from './firebase'
import type { CalendarPreferences } from '../types/schema'

export const subscribeToCalendarPreferences = (
  uid: string,
  callback: (preferences: Partial<CalendarPreferences>) => void,
): Unsubscribe => {
  if (!uid) {
    return () => {}
  }
  return onSnapshot(
    doc(firestoreDb, 'users', uid),
    (snapshot) => {
      const data = snapshot.data() as
        | { calendarPreferences?: Partial<CalendarPreferences> }
        | undefined
      const incoming = data?.calendarPreferences
      if (!incoming) return
      callback(incoming)
    },
    (error) => {
      console.warn('[calendarPreferencesService] subscription failed', error)
    },
  )
}

export const updateCalendarPreferences = async (
  uid: string,
  patch: Partial<CalendarPreferences>,
): Promise<void> => {
  if (!uid) return
  await setDoc(
    doc(firestoreDb, 'users', uid),
    { calendarPreferences: patch },
    { merge: true },
  )
}
